import {
  Button,
  Modal,
  Row,
  message,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import {
  buyerCampaigns,
  cartDetails,
  deleteCampaign,
  deleteCampaignFromCart,
  deleteCampaignProduct,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { useDispatch, useSelector } from "react-redux";
import "./DeleteCampaign.css";
import { getCampaignsForPurchase } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { capitalizeFirst } from "../../common/utils/Utils";
const { Text } = Typography;
const DeleteCamapign = ({
  deleteCampaignId,
  deleteProductId,
  setDeleteCampaignModal,
  deleteCampaignModal,
  selectedCampaignPage = true,
  type,
  productId,
  price,
  campaignPurchase = false,
  buttonText = "delete",
}) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.campaignscart);
  const { isDeletingCampaign } = useSelector((state) => state?.buyerCampaigns);
  const handleDelete = () => {
    if (selectedCampaignPage) {
      if (!deleteCampaignId) {
        return;
      }
      dispatch(deleteCampaign(deleteCampaignId)).then((res) => {
        message.success(res?.payload?.message);
      });
    } else if (type === "deleteProduct") {
      let campaignId = deleteCampaignId;
      const payload = {
        campaignId: campaignId || deleteProductId?.id,
        productId: productId || deleteProductId?.product_id,
        price: price || deleteProductId?.price,
      };
      dispatch(deleteCampaignProduct(payload)).then((res) => {
        dispatch(buyerCampaigns(deleteCampaignId));
        message.success(res?.payload?.message);
        if (campaignPurchase) {
          dispatch(getCampaignsForPurchase());
        }
      });
    } else {
      if (!deleteCampaignId) {
        return;
      }
      dispatch(deleteCampaignFromCart(deleteCampaignId)).then((res) => {
        message.success(res?.payload?.message);
        dispatch(cartDetails("campaignCart"));
      });
    }
    setDeleteCampaignModal(false);
  };
  return (
    <div>
      <Modal
        open={deleteCampaignModal}
        footer={false}
        className="billboard-dialog"
        closable={false}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "40%",
          xxl: "30%",
        }}
        centered
      >
        <Row>
          <Text className="delete-header">
            Are you sure you want to {buttonText} this?
          </Text>
        </Row>
        <Row>
          <Text className="delete-content">
            This action is permanent and cannot be undone. Please double-check
            before proceeding.
          </Text>
        </Row>
        <Row
          justify="end"
          align="middle"
          className="delete-campaign-cancel-button"
        >
          <Button
            className="billboard-buttons billboard-button-1"
            onClick={() => setDeleteCampaignModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="billboard-buttons billboard-button-2"
            onClick={handleDelete}
          >
            {"Yes, " + capitalizeFirst(buttonText) + " It"}
          </Button>
        </Row>
      </Modal>
      {isLoading ||
        (isDeletingCampaign && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        ))}
    </div>
  );
};
export default DeleteCamapign;
